import md5 from "js-md5";
import generateString from "@/components/Account/accountUtils/utils.js";
import { mapState } from "vuex";
import errorsCodes from '@/utils/errors'

const BRAND_TOKEN = "da2ab7d7-810a-41b2-be51-6547d6fdc841";
const BASE_URI_ACTIONS =
  "https://widelyapp-api-01.x2one.com:3001/api/v2/actions";
const BASE_URI =
  "https://widelyapp-api-01.x2one.com:3001/api/v2/widely_app/app_action";

export default {
    data() {
        return {
            loaded: false
        }
    },
    computed: {
        ...mapState({
          account: (state) => state.account.account,
          user: (state) => state.user.profile,
          accountOwner: (state) => state.user.accountOwner,
          authId: (state) => state.account.authId,
          authToken: (state) => state.account.authToken
        }),
    },

    methods: {
        async makeApiRequest(appAction, functionName, requestBody) {
            this.loaded = false
            const hash = generateString(10);
            const reqBody = {
                auth: {
                    auth_id: appAction ? 1 : this.authId,//this.account.auth_id,
                    hash: hash,
                    auth: appAction ? md5(BRAND_TOKEN + hash) : md5(this.authToken + md5(BRAND_TOKEN + hash)), // md5(this.account.token + md5(BRAND_TOKEN + hash)),
                },
                func_name: functionName,
                data: requestBody
            };
            try {
                const { data } = await this.$axios.post(appAction ? BASE_URI : BASE_URI_ACTIONS, reqBody);
                // console.log('data in mixin ', data);
                if (data.error_code === 200) {
                    return data
                }
                else return errorsCodes[data.error_code]
            } catch (e) {
                console.error(e);
            } finally {
                this.loaded = true
            }

        },
    }
  };
  